import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ionic/angular';

var _c0 = ["*"];
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, ElementRef, Renderer2, Output, EventEmitter } from '@angular/core';
import { Platform, DomController } from '@ionic/angular';
import { SheetState } from './ion-bottom-sheet-state';
import * as Hammer from 'hammerjs';
var HTML_TEMPLATE = "\n<div id=\"ibs-header\" class=\"separator\">\n  <div id=\"ibs-header-content\">\n    <div id=\"drag-icon\"></div>\n    <div id=\"title-button\">\n      <div id=\"title\">{{ title }}</div>\n      <div id=\"close-button\" (click)=\"closeSheet()\"></div>\n    </div>\n  </div> \n</div>\n<div id=\"ibs-content\">\n  <ng-content></ng-content>\n</div>\n";
var CSS_STYLE = "\n  :host  {\n    touch-action: none;\n    padding: 5px;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    z-index: 999 !important;\n    background-color: white;\n    transition: none;\n    will-change: transform;\n  }\n\n  :host.round-border {\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n  }\n\n  :host.shadow-border {\n    box-shadow: 0px 4px 16px  rgba(0, 0, 0, 0.12);\n  }\n\n  :host #ibs-header{\n    position: fixed;\n    top:0;\n    left:0;\n    padding: 5px;\n    width: 100%;\n    z-index: 888;\n    min-height: 35px;\n  }\n\n  :host .separator{\n    border-bottom-style: solid;\n    border-bottom-color: rgba(220, 220, 220, 1);\n    border-bottom-width: 1px;\n  }\n\n  :host .bottom-shadow-border{\n    box-shadow: 0px 3px 3px  rgba(0, 0, 0, 0.12);\n  }\n\n  :host #ibs-header-content{\n    background-color: inherit;\n    width: 100%;\n    height: 100%;\n  }\n\n  :host #drag-icon{\n    margin: 0 auto;\n    height: 5px;\n    width: 36px;\n    background-color: #c0c0c0;\n    border-radius: 4px;\n  }\n\n  :host #title-button{\n    width: 100%;\n    height: 100%;\n    position: relative;\n    height: 26px;\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n\n  :host #close-button{\n    width: 26px;\n    height: 26px;\n    position: absolute;\n    right: 10px;\n    background: #c0c0c0;\n    border-radius: 100%;\n    content: url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"> <path fill=\"7a7a7e\" d=\"M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z\"/> </svg>');\n  }\n\n  :host #title{\n    position: absolute;\n    left: 10px;\n    padding: 0px;\n    margin: 0px;\n    font-size: 20px;\n    line-height: 26px;\n    color: inherit; \n  }\n\n  :host .txt-center{\n    text-align: center;\n    width: 100%;\n    left: 0px !important;\n  }\n\n  :host #ibs-content{\n    touch-action: none;\n    overflow: hidden;\n    margin-top: 45px\n  }\n\n  :host .fadeOut {\n    visibility: hidden;\n    opacity: 0;\n    transition: visibility 0s linear 700ms, opacity 700ms;  \n  }\n\n  :host .fadeIn {\n    visibility: visible;\n    opacity: 1;\n    transition: visibility 0s linear 0s, opacity 300ms;\n  }\n\n  :host #tb-content {\n    position: relative;\n  }\n\n  :host.no-drag-icon #drag-icon,\n  :host.no-close-btn #close-button,\n  :host.no-title #title,\n  :host.no-header #ibs-header {\n    display: none !important;\n  }\n\n  :host.no-title #title-button {\n    margin-top: 0px;\n  }\n\n  :host.no-title.no-drag-icon #title-button {\n    margin-top: 5px;\n  }\n\n  :host.no-title #ibs-content {\n    margin-top: 40px;\n  }\n\n  :host.no-drag-icon #ibs-content {\n    margin-top: 40px;\n  }\n\n  :host.no-header #ibs-content {\n    margin-top: 0px !important;\n  }\n\n  :host.no-drag-icon.no-title #ibs-content {\n    margin-top: 40px;\n  }\n\n  :host.no-title.no-close-btn #title-button {\n    margin-bottom: 0px;\n  }\n\n  :host.no-title.no-close-btn #ibs-content {\n    margin-top: 35px;\n  }\n\n  :host.no-drag-icon.no-title.no-close-btn #title-button {\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :host.no-drag-icon.no-title.no-close-btn #ibs-content {\n    margin-top: 30px;\n  }\n";
var IonBottomSheetComponent = /** @class */ (function () {
    function IonBottomSheetComponent(_element, _renderer, _domCtrl, _platform) {
        this._element = _element;
        this._renderer = _renderer;
        this._domCtrl = _domCtrl;
        this._platform = _platform;
        this.dockedHeight = 50;
        this.canBounce = true;
        this.roundBorder = true;
        this.roundBorderOnTop = false;
        this.shadowBorder = true;
        this.shadowBorderOnTop = false;
        this.disableDrag = false;
        this.hideCloseButton = false;
        this.hideCloseButtonOnTop = false;
        this.hideDragIcon = false;
        this.hideDragIconOnTop = false;
        this.hideTitle = false;
        this.hideHeader = false;
        this.hideSeparator = false;
        this.titleCentered = false;
        this.titleSize = "20px";
        this.titleFamily = "inherit";
        this.topDistance = 0;
        this.transition = '0.1s ease-in-out';
        this.state = SheetState.Bottom;
        this.minHeight = 0;
        this.title = "Header Title";
        this.stateChange = new EventEmitter();
        this._BOUNCE_DELTA = 30;
        this._hasBeenPerformed = false;
    }
    /*********************************************************************************************************/
    /* Ng interface implements */
    /*********************************************************************************************************/
    IonBottomSheetComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // define new events when animation start and stop
        this._element.nativeElement.addEventListener("transitionend", this._checkForAnimation.bind(this));
        // define css style
        this._cssManageClass("no-close-btn", this.hideCloseButton ? "add" : "remove");
        this._cssManageClass("no-drag-icon", this.hideDragIcon ? "add" : "remove");
        this._cssManageClass("no-title", this.hideTitle ? "add" : "remove");
        this._cssManageClass("no-header", this.hideHeader ? "add" : "remove");
        this._cssManageClass("separator", this.hideSeparator ? "remove" : "add", "#ibs-header");
        this._cssManageClass("round-border", this.roundBorder ? "add" : "remove");
        this._cssManageClass("shadow-border", this.shadowBorder ? "add" : "remove");
        this._cssManageClass("txt-center", this.titleCentered ? "add" : "remove", "#title");
        this._setStyle("font-size", this.titleSize, "#title");
        this._setStyle("font-family", this.titleFamily, "#title");
        if (this.disableDrag) {
            return;
        }
        // config gesture
        var hammer = new Hammer(this._element.nativeElement);
        hammer.get('pan').set({ enable: true, direction: Hammer.DIRECTION_VERTICAL });
        hammer.on('pan panstart panend', function (ev) {
            switch (ev.type) {
                case 'panstart':
                    _this._onGestureStart();
                    break;
                case 'panend':
                    _this._onGestureEnd(ev);
                    break;
                default:
                    _this._onGestureMove(ev);
            }
        });
    };
    IonBottomSheetComponent.prototype.ngOnChanges = function (changes) {
        if (!changes.state) {
            return;
        }
        this._setSheetState(changes.state.currentValue);
    };
    /*********************************************************************************************************/
    /* Base class methods                                                                                    */
    /*********************************************************************************************************/
    IonBottomSheetComponent.prototype._setSheetState = function (state) {
        this._setStyle('transition', this.transition);
        switch (state) {
            case SheetState.Bottom:
                this._setTranslateY('calc(100vh - ' + this.minHeight + 'px)');
                break;
            case SheetState.Docked:
                this._setTranslateY('calc(100vh - ' + this.dockedHeight + 'px)');
                break;
            case SheetState.Top:
                this._setTranslateY(this.topDistance + 'px');
                break;
        }
    };
    IonBottomSheetComponent.prototype._getPosition = function (currentState) {
        switch (currentState) {
            case SheetState.Bottom:
                return this._platform.height() - this.minHeight;
            case SheetState.Docked:
                return this._platform.height() - this.dockedHeight;
            case SheetState.Top:
                return this.topDistance;
        }
    };
    IonBottomSheetComponent.prototype._nextSate = function (currentState, gestureDirection) {
        switch (currentState) {
            case SheetState.Bottom:
                return gestureDirection < 0 ? SheetState.Docked : SheetState.Bottom;
            case SheetState.Docked:
                return gestureDirection < 0 ? SheetState.Top : SheetState.Bottom;
            case SheetState.Top:
                return gestureDirection < 0 ? SheetState.Top : SheetState.Docked;
        }
    };
    IonBottomSheetComponent.prototype._checkForAnimation = function () {
        if (this._element.nativeElement.getBoundingClientRect().y == this._getPosition(SheetState.Top)) {
            if (this._hasBeenPerformed) {
                return;
            }
            this._hasBeenPerformed = true;
        }
        else {
            if (!this._hasBeenPerformed) {
                return;
            }
            this._hasBeenPerformed = false;
        }
        if (!this.roundBorderOnTop && this.roundBorder) {
            this._cssManageClass("round-border", this._hasBeenPerformed ? "remove" : "add", null);
        }
        if (!this.shadowBorderOnTop && this.shadowBorder) {
            this._cssManageClass("shadow-border", this._hasBeenPerformed ? "remove" : "add", null);
        }
        if (this.hideDragIconOnTop && !this.hideDragIcon) {
            this._cssSwitchClass(this._hasBeenPerformed ? "fadeOut" : "fadeIn", this._hasBeenPerformed ? "fadeIn" : "fadeOut", "#drag-icon");
        }
        if (this.hideCloseButtonOnTop && !this.hideCloseButton) {
            this._cssSwitchClass(this._hasBeenPerformed ? "fadeOut" : "fadeIn", this._hasBeenPerformed ? "fadeIn" : "fadeOut", "#close-button");
        }
    };
    IonBottomSheetComponent.prototype._cssSwitchClass = function (entryClassName, exitClassName, selector) {
        this._renderer.removeClass(this._element.nativeElement.querySelector(selector), exitClassName);
        this._renderer.addClass(this._element.nativeElement.querySelector(selector), entryClassName);
    };
    IonBottomSheetComponent.prototype._cssManageClass = function (className, action, selector) {
        var _this = this;
        if (selector === void 0) { selector = null; }
        this._domCtrl.write(function () {
            action == "add" ? _this._cssAddClass(className, selector) : _this._cssRemoveClass(className, selector);
        });
    };
    IonBottomSheetComponent.prototype._cssAddClass = function (className, selector) {
        var _this = this;
        if (selector === void 0) { selector = null; }
        this._domCtrl.write(function () {
            _this._renderer.addClass(selector == null ? _this._element.nativeElement : _this._element.nativeElement.querySelector(selector), className);
        });
    };
    IonBottomSheetComponent.prototype._cssRemoveClass = function (className, selector) {
        var _this = this;
        if (selector === void 0) { selector = null; }
        this._domCtrl.write(function () {
            _this._renderer.removeClass(selector == null ? _this._element.nativeElement : _this._element.nativeElement.querySelector(selector), className);
        });
    };
    IonBottomSheetComponent.prototype._setStyle = function (property, value, selector) {
        var _this = this;
        if (selector === void 0) { selector = null; }
        this._domCtrl.write(function () {
            if (selector != null) {
                _this._renderer.setStyle(_this._element.nativeElement.querySelector(selector), property, value);
            }
            else {
                _this._renderer.setStyle(_this._element.nativeElement, property, value);
            }
        });
    };
    IonBottomSheetComponent.prototype._setTranslateY = function (value) {
        this._setStyle('transform', 'translateY(' + value + ')');
    };
    /*********************************************************************************************************/
    /* Gestures                                                                                              */
    /*********************************************************************************************************/
    IonBottomSheetComponent.prototype._onGestureStart = function () {
        this._setStyle('transition', 'none');
        this._startPosition = this._element.nativeElement.getBoundingClientRect().y;
    };
    IonBottomSheetComponent.prototype._onGestureEnd = function (ev) {
        if (this.canBounce == false) {
            return;
        }
        if (Math.abs(ev.deltaY) > this._BOUNCE_DELTA) {
            this.stateChange.emit(this.state = this._nextSate(this.state, ev.deltaY));
        }
        else {
            this._setStyle('transition', this.transition);
            this._setTranslateY(this._getPosition(this.state) + "px");
        }
    };
    IonBottomSheetComponent.prototype._onGestureMove = function (ev) {
        var nextYposition = this._startPosition + ev.deltaY;
        if ((nextYposition <= this._getPosition(SheetState.Top)) && (ev.deltaY < 0)) {
            nextYposition = this._getPosition(SheetState.Top);
        }
        if ((nextYposition >= this._getPosition(SheetState.Bottom)) && (ev.deltaY > 0)) {
            nextYposition = this._getPosition(SheetState.Bottom);
        }
        this._setTranslateY(nextYposition + "px");
        this._checkForAnimation();
    };
    /*********************************************************************************************************/
    /* Button's action                                                                                       */
    /*********************************************************************************************************/
    IonBottomSheetComponent.prototype.closeSheet = function () {
        this.stateChange.emit(this.state = SheetState.Bottom);
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "dockedHeight", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "canBounce", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "roundBorder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "roundBorderOnTop", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "shadowBorder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "shadowBorderOnTop", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "disableDrag", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "hideCloseButton", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "hideCloseButtonOnTop", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "hideDragIcon", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "hideDragIconOnTop", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "hideTitle", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "hideHeader", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "hideSeparator", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "titleCentered", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "titleSize", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "titleFamily", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "topDistance", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "transition", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], IonBottomSheetComponent.prototype, "state", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "minHeight", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], IonBottomSheetComponent.prototype, "title", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], IonBottomSheetComponent.prototype, "stateChange", void 0);
    IonBottomSheetComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            DomController,
            Platform])
    ], IonBottomSheetComponent);
IonBottomSheetComponent.ɵfac = function IonBottomSheetComponent_Factory(t) { return new (t || IonBottomSheetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomController), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Platform)); };
IonBottomSheetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: IonBottomSheetComponent, selectors: [["ion-bottom-sheet"]], inputs: { dockedHeight: "dockedHeight", canBounce: "canBounce", roundBorder: "roundBorder", roundBorderOnTop: "roundBorderOnTop", shadowBorder: "shadowBorder", shadowBorderOnTop: "shadowBorderOnTop", disableDrag: "disableDrag", hideCloseButton: "hideCloseButton", hideCloseButtonOnTop: "hideCloseButtonOnTop", hideDragIcon: "hideDragIcon", hideDragIconOnTop: "hideDragIconOnTop", hideTitle: "hideTitle", hideHeader: "hideHeader", hideSeparator: "hideSeparator", titleCentered: "titleCentered", titleSize: "titleSize", titleFamily: "titleFamily", topDistance: "topDistance", transition: "transition", state: "state", minHeight: "minHeight", title: "title" }, outputs: { stateChange: "stateChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0, decls: 9, vars: 1, consts: [["id", "ibs-header", 1, "separator"], ["id", "ibs-header-content"], ["id", "drag-icon"], ["id", "title-button"], ["id", "title"], ["id", "close-button", 3, "click"], ["id", "ibs-content"]], template: function IonBottomSheetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵlistener("click", function IonBottomSheetComponent_Template_div_click_6_listener() { return ctx.closeSheet(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
    } }, styles: ["[_nghost-%COMP%]  {\n    touch-action: none;\n    padding: 5px;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    z-index: 999 !important;\n    background-color: white;\n    transition: none;\n    will-change: transform;\n  }\n\n  .round-border[_nghost-%COMP%] {\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n  }\n\n  .shadow-border[_nghost-%COMP%] {\n    box-shadow: 0px 4px 16px  rgba(0, 0, 0, 0.12);\n  }\n\n  [_nghost-%COMP%]   #ibs-header[_ngcontent-%COMP%]{\n    position: fixed;\n    top:0;\n    left:0;\n    padding: 5px;\n    width: 100%;\n    z-index: 888;\n    min-height: 35px;\n  }\n\n  [_nghost-%COMP%]   .separator[_ngcontent-%COMP%]{\n    border-bottom-style: solid;\n    border-bottom-color: rgba(220, 220, 220, 1);\n    border-bottom-width: 1px;\n  }\n\n  [_nghost-%COMP%]   .bottom-shadow-border[_ngcontent-%COMP%]{\n    box-shadow: 0px 3px 3px  rgba(0, 0, 0, 0.12);\n  }\n\n  [_nghost-%COMP%]   #ibs-header-content[_ngcontent-%COMP%]{\n    background-color: inherit;\n    width: 100%;\n    height: 100%;\n  }\n\n  [_nghost-%COMP%]   #drag-icon[_ngcontent-%COMP%]{\n    margin: 0 auto;\n    height: 5px;\n    width: 36px;\n    background-color: #c0c0c0;\n    border-radius: 4px;\n  }\n\n  [_nghost-%COMP%]   #title-button[_ngcontent-%COMP%]{\n    width: 100%;\n    height: 100%;\n    position: relative;\n    height: 26px;\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n\n  [_nghost-%COMP%]   #close-button[_ngcontent-%COMP%]{\n    width: 26px;\n    height: 26px;\n    position: absolute;\n    right: 10px;\n    background: #c0c0c0;\n    border-radius: 100%;\n    content: url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"> <path fill=\"7a7a7e\" d=\"M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z\"/> </svg>');\n  }\n\n  [_nghost-%COMP%]   #title[_ngcontent-%COMP%]{\n    position: absolute;\n    left: 10px;\n    padding: 0px;\n    margin: 0px;\n    font-size: 20px;\n    line-height: 26px;\n    color: inherit; \n  }\n\n  [_nghost-%COMP%]   .txt-center[_ngcontent-%COMP%]{\n    text-align: center;\n    width: 100%;\n    left: 0px !important;\n  }\n\n  [_nghost-%COMP%]   #ibs-content[_ngcontent-%COMP%]{\n    touch-action: none;\n    overflow: hidden;\n    margin-top: 45px\n  }\n\n  [_nghost-%COMP%]   .fadeOut[_ngcontent-%COMP%] {\n    visibility: hidden;\n    opacity: 0;\n    transition: visibility 0s linear 700ms, opacity 700ms;  \n  }\n\n  [_nghost-%COMP%]   .fadeIn[_ngcontent-%COMP%] {\n    visibility: visible;\n    opacity: 1;\n    transition: visibility 0s linear 0s, opacity 300ms;\n  }\n\n  [_nghost-%COMP%]   #tb-content[_ngcontent-%COMP%] {\n    position: relative;\n  }\n\n  .no-drag-icon[_nghost-%COMP%]   #drag-icon[_ngcontent-%COMP%], .no-close-btn[_nghost-%COMP%]   #close-button[_ngcontent-%COMP%], .no-title[_nghost-%COMP%]   #title[_ngcontent-%COMP%], .no-header[_nghost-%COMP%]   #ibs-header[_ngcontent-%COMP%] {\n    display: none !important;\n  }\n\n  .no-title[_nghost-%COMP%]   #title-button[_ngcontent-%COMP%] {\n    margin-top: 0px;\n  }\n\n  .no-title.no-drag-icon[_nghost-%COMP%]   #title-button[_ngcontent-%COMP%] {\n    margin-top: 5px;\n  }\n\n  .no-title[_nghost-%COMP%]   #ibs-content[_ngcontent-%COMP%] {\n    margin-top: 40px;\n  }\n\n  .no-drag-icon[_nghost-%COMP%]   #ibs-content[_ngcontent-%COMP%] {\n    margin-top: 40px;\n  }\n\n  .no-header[_nghost-%COMP%]   #ibs-content[_ngcontent-%COMP%] {\n    margin-top: 0px !important;\n  }\n\n  .no-drag-icon.no-title[_nghost-%COMP%]   #ibs-content[_ngcontent-%COMP%] {\n    margin-top: 40px;\n  }\n\n  .no-title.no-close-btn[_nghost-%COMP%]   #title-button[_ngcontent-%COMP%] {\n    margin-bottom: 0px;\n  }\n\n  .no-title.no-close-btn[_nghost-%COMP%]   #ibs-content[_ngcontent-%COMP%] {\n    margin-top: 35px;\n  }\n\n  .no-drag-icon.no-title.no-close-btn[_nghost-%COMP%]   #title-button[_ngcontent-%COMP%] {\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  .no-drag-icon.no-title.no-close-btn[_nghost-%COMP%]   #ibs-content[_ngcontent-%COMP%] {\n    margin-top: 30px;\n  }"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IonBottomSheetComponent, [{
        type: Component,
        args: [{
                selector: 'ion-bottom-sheet',
                template: HTML_TEMPLATE,
                styles: [CSS_STYLE]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc1.DomController }, { type: ɵngcc1.Platform }]; }, { dockedHeight: [{
            type: Input
        }], canBounce: [{
            type: Input
        }], roundBorder: [{
            type: Input
        }], roundBorderOnTop: [{
            type: Input
        }], shadowBorder: [{
            type: Input
        }], shadowBorderOnTop: [{
            type: Input
        }], disableDrag: [{
            type: Input
        }], hideCloseButton: [{
            type: Input
        }], hideCloseButtonOnTop: [{
            type: Input
        }], hideDragIcon: [{
            type: Input
        }], hideDragIconOnTop: [{
            type: Input
        }], hideTitle: [{
            type: Input
        }], hideHeader: [{
            type: Input
        }], hideSeparator: [{
            type: Input
        }], titleCentered: [{
            type: Input
        }], titleSize: [{
            type: Input
        }], titleFamily: [{
            type: Input
        }], topDistance: [{
            type: Input
        }], transition: [{
            type: Input
        }], state: [{
            type: Input
        }], minHeight: [{
            type: Input
        }], title: [{
            type: Input
        }], stateChange: [{
            type: Output
        }] }); })();
    return IonBottomSheetComponent;
}());
export { IonBottomSheetComponent };

//# sourceMappingURL=ion-bottom-sheet.component.js.map